export default class {
  constructor() {
    this.listeners = {}
  }

  on(event, listener) {
    if (event in this.listeners) {
      this.listeners[event].push(listener)
    } else {
      this.listeners[event] = [listener]
    }
    return this
  }

  emit(event, ...arg) {
    if (event in this.listeners) {
      for (let i = 0; i < this.listeners[event].length; i ++) {
        this.listeners[event][i](...arg)
      }
      return true
    }
    return false
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/share/EventEmitter.js